// extracted by mini-css-extract-plugin
export default {"applePayButton":"cPF8f2QMwPcB7ajfWRWr"};